import React from 'react'

import { getShellByElementId } from 'components/Editor/EditorContext/selectors/block'
import { getShellName } from 'components/Editor/EditorContext/selectors/blockLabels'
import type { CommentMock } from 'components/comments/types'
import { KitSize } from 'components/uiKit/KitTypes'
import type { ITypographyProps } from 'components/uiKit/Typography'
import { Typography } from 'components/uiKit/Typography'
import type { Block } from 'services/Store/Project/types'

interface IPathProps extends Partial<ITypographyProps> {
  comment: CommentMock
  block?: Pick<Block, 'schema' | 'elements'> | null
}

const Path: React.FC<IPathProps> = ({ comment, block, ...rest }) => {
  const { elementId, blockIndex = 0 } = comment

  const shellId = block && elementId && getShellByElementId(block, elementId)
  const elementName = block && shellId && getShellName(block, shellId)

  return (
    <Typography size={KitSize.XS} styleType='hint' weight='medium' {...rest}>
      #{(blockIndex || 0) + 1}
      {elementId && ` / ${elementName || '...'}`}
    </Typography>
  )
}

export default Path
